import { Routes } from "@angular/router";
import { anonymousGuard } from "./guards/anonymous.guard";
import { authGuard } from "./guards/auth.guard";
import { LoginPageComponent } from "./components/pages/login-page/login-page.component";
import { TrackerPageComponent } from "./components/pages/tracker-page/tracker-page.component";
import { TagManagerPageComponent } from "./components/pages/tag-manager-page/tag-manager-page.component";
import { ProjectsPageComponent } from "./components/pages/projects-page/projects-page.component";
import { ClientsPageComponent } from "./components/pages/clients-page/clients-page.component";
import { ReportsPageComponent } from "./components/pages/reports-page/reports-page.component";
import { MembersPageComponent } from "./components/pages/members-page/members-page.component";

export const routes: Routes = [
  // Login page.
  {
    path: 'login',
    component: LoginPageComponent,
    canActivate: [anonymousGuard],
  },

  // General pages.
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'tracker-page', component: TrackerPageComponent },
      { path: 'tags', component: TagManagerPageComponent },
      { path: 'projects-page', component: ProjectsPageComponent },
      { path: 'clients-page', component: ClientsPageComponent },
      { path: 'reports-page', component: ReportsPageComponent },
      { path: 'members-page', component: MembersPageComponent },
      { path: '', redirectTo: '/tracker-page', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: '/tracker-page', pathMatch: 'full' },
];
